import API from '../utils/api';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
    IMPERSONATE_USER_REQUESTED,
} from '../actions/types';

import {
    impersonateUserSuccess,
    impersonateUserFailed,
} from '../actions/impersonateAction';

export function* impersonateUser({ payload }) {
    try {
        const response = yield call(API.getData, `users/${payload}/impersonate`);
        yield put(impersonateUserSuccess(response));
    } catch (error) {
        yield put(impersonateUserFailed(error));
    }
}

export default function* impersonateSaga() {
    yield takeLatest(IMPERSONATE_USER_REQUESTED, impersonateUser);
}
